module.exports = __webpack_public_path__ + "media/images/admin-background-7a129003d61236530b84b3d2036d106d.jpg";